import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { api } from "@/lib/api";
import { useRealtimeEvent } from "@/lib/realtime";
import { useI18n } from "@/i18n/I18nContext";

export const useUnread = () => {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["inbox-unread"], queryFn: () => api.get("/inbox/unread").then((r) => r.data.unread), refetchInterval: 60000 });
  useRealtimeEvent((m) => {
    if (m.type === "inbox_changed" || m.type === "announcements_changed") {
      qc.invalidateQueries({ queryKey: ["inbox-unread"] });
      qc.invalidateQueries({ queryKey: ["inbox"] });
    }
  });
  return data || 0;
};

export const InboxBell = () => {
  const { t } = useI18n();
  const n = useUnread();
  return (
    <Link to="/messages" aria-label={t("inbox.title")} className="relative flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/5 text-slate-200 transition-colors hover:bg-white/10" data-testid="header-inbox-btn">
      <Mail className="h-5 w-5" />
      {n > 0 && (
        <span className="absolute -right-1 -top-1 flex h-5 min-w-[20px] items-center justify-center rounded-full bg-red-500 px-1 text-[11px] font-bold text-white" data-testid="header-inbox-badge">
          {n > 99 ? "99+" : n}
        </span>
      )}
    </Link>
  );
};
